// extracted by mini-css-extract-plugin
export default {"light":"Light_light__W8Wy9"};